import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d21b176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "detail-box" }
const _hoisted_3 = { class: "detail-title" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "show-data" }
const _hoisted_6 = { class: "detail-content" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "operate-row" }
const _hoisted_9 = {
  key: 0,
  class: "dz _select"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 点赞 ")
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 点赞 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_pdf = _resolveComponent("pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.params.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, "点赞 " + _toDisplayString(_ctx.showData.browseNum), 1),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fBrowse && _ctx.fBrowse(...args)))
          }, _toDisplayString(_ctx.showData.browseNum) + " 人浏览 >", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_pdf, { ref: "pdf" }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.showData.thumbUp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: require('@/assets/disciplinesafe/dz.png')
                }, null, 8, _hoisted_10),
                _hoisted_11
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "dz",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fDz && _ctx.fDz(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/disciplinesafe/wdz.png')
                }, null, 8, _hoisted_12),
                _hoisted_13
              ]))
        ])
      ])
    ])
  ]))
}